module.exports = __webpack_public_path__ + "img/yahoo.3b752456.png";